/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Created_Join_FailedInputs */

const th_player_created_join_failed = /** @type {(inputs: Player_Created_Join_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างผู้เล่นแล้ว แต่เพิ่มเข้าทีมไม่สำเร็จ ลองอีกครั้งเพื่อเพิ่มผู้เล่นคนเดิม`)
};

const en_player_created_join_failed = /** @type {(inputs: Player_Created_Join_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The player was created, but could not be added to this squad. Retry to add the same player.`)
};

const ja_player_created_join_failed = /** @type {(inputs: Player_Created_Join_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選手を作成しましたが、チームに追加できませんでした。再試行すると同じ選手を追加します。`)
};

const zh_player_created_join_failed = /** @type {(inputs: Player_Created_Join_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球员已创建，但未能加入此阵容。重试即可添加同一名球员。`)
};

const es_player_created_join_failed = /** @type {(inputs: Player_Created_Join_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El jugador se ha creado, pero no se ha podido añadir a esta plantilla. Reinténtalo para añadir al mismo jugador.`)
};

const pt_player_created_join_failed = /** @type {(inputs: Player_Created_Join_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O jogador foi criado, mas não pôde ser adicionado a este elenco. Tente de novo para adicionar o mesmo jogador.`)
};

const id_player_created_join_failed = /** @type {(inputs: Player_Created_Join_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemain dibuat, tapi tidak bisa dimasukkan ke skuad ini. Coba lagi untuk menambahkan pemain yang sama.`)
};

const fr_player_created_join_failed = /** @type {(inputs: Player_Created_Join_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le joueur a été créé mais n’a pas pu être ajouté à cet effectif. Réessayez pour ajouter le même joueur.`)
};

const tl_player_created_join_failed = /** @type {(inputs: Player_Created_Join_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nagawa ang manlalaro ngunit hindi naisama sa squad na ito. Subukang muli para idagdag ang parehong manlalaro.`)
};

const vi_player_created_join_failed = /** @type {(inputs: Player_Created_Join_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã tạo cầu thủ nhưng không thêm được vào đội hình này. Thử lại để thêm chính cầu thủ đó.`)
};

const ko_player_created_join_failed = /** @type {(inputs: Player_Created_Join_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선수를 만들었지만 이 선수단에 넣지 못했습니다. 같은 선수를 추가하려면 다시 시도하세요.`)
};

const de_player_created_join_failed = /** @type {(inputs: Player_Created_Join_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Spieler wurde angelegt, konnte aber nicht in diesen Kader aufgenommen werden. Versuche es erneut, um denselben Spieler hinzuzufügen.`)
};

const ru_player_created_join_failed = /** @type {(inputs: Player_Created_Join_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игрок создан, но не добавлен в этот состав. Попробуйте снова, чтобы добавить того же игрока.`)
};

const tr_player_created_join_failed = /** @type {(inputs: Player_Created_Join_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oyuncu oluşturuldu ama bu kadroya eklenemedi. Aynı oyuncuyu eklemek için yeniden deneyin.`)
};

const it_player_created_join_failed = /** @type {(inputs: Player_Created_Join_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il giocatore è stato creato ma non è stato aggiunto a questa rosa. Riprova per aggiungere lo stesso giocatore.`)
};

const pl_player_created_join_failed = /** @type {(inputs: Player_Created_Join_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zawodnik został utworzony, ale nie udało się dodać go do tego składu. Spróbuj ponownie, aby dodać tego samego zawodnika.`)
};

const uk_player_created_join_failed = /** @type {(inputs: Player_Created_Join_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Гравця створено, але не додано до цього складу. Спробуйте ще раз, щоб додати того самого гравця.`)
};

const hi_player_created_join_failed = /** @type {(inputs: Player_Created_Join_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खिलाड़ी बन गया पर इस टीम में नहीं जुड़ सका। उसी खिलाड़ी को जोड़ने के लिए फिर कोशिश करें।`)
};

const ar_player_created_join_failed = /** @type {(inputs: Player_Created_Join_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أُنشئ اللاعب لكن تعذّر ضمّه إلى هذه التشكيلة. أعد المحاولة لإضافة اللاعب نفسه.`)
};

const ms_player_created_join_failed = /** @type {(inputs: Player_Created_Join_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemain dicipta tetapi tidak dapat dimasukkan ke skuad ini. Cuba lagi untuk menambah pemain yang sama.`)
};

const bn_player_created_join_failed = /** @type {(inputs: Player_Created_Join_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`খেলোয়াড় তৈরি হয়েছে কিন্তু এই দলে যোগ করা যায়নি। একই খেলোয়াড়কে যোগ করতে আবার চেষ্টা করুন।`)
};

const zh_tw2_player_created_join_failed = /** @type {(inputs: Player_Created_Join_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球員已建立，但未能加入這份名單。重試即可加入同一位球員。`)
};

const zh_hk2_player_created_join_failed = /** @type {(inputs: Player_Created_Join_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球員已建立，但未能加入這份名單。重試即可加入同一位球員。`)
};

const ur_player_created_join_failed = /** @type {(inputs: Player_Created_Join_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کھلاڑی بن گیا مگر اس اسکواڈ میں شامل نہیں ہو سکا۔ اسی کھلاڑی کو شامل کرنے کے لیے دوبارہ کوشش کریں۔`)
};

const fa_player_created_join_failed = /** @type {(inputs: Player_Created_Join_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بازیکن ساخته شد اما به این فهرست تیم افزوده نشد. برای افزودن همان بازیکن دوباره تلاش کنید.`)
};

const sw_player_created_join_failed = /** @type {(inputs: Player_Created_Join_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mchezaji amefunguliwa lakini hakuweza kuingizwa kwenye kikosi hiki. Jaribu tena ili kumwongeza mchezaji yuleyule.`)
};

const nl_player_created_join_failed = /** @type {(inputs: Player_Created_Join_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De speler is aangemaakt maar kon niet aan deze selectie worden toegevoegd. Probeer opnieuw om dezelfde speler toe te voegen.`)
};

/**
* | output |
* | --- |
* | "The player was created, but could not be added to this squad. Retry to add the same player." |
*
* @param {Player_Created_Join_FailedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const player_created_join_failed = /** @type {((inputs?: Player_Created_Join_FailedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Created_Join_FailedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_player_created_join_failed(inputs)
	if (locale === "ja") return ja_player_created_join_failed(inputs)
	if (locale === "zh") return zh_player_created_join_failed(inputs)
	if (locale === "es") return es_player_created_join_failed(inputs)
	if (locale === "pt") return pt_player_created_join_failed(inputs)
	if (locale === "id") return id_player_created_join_failed(inputs)
	if (locale === "fr") return fr_player_created_join_failed(inputs)
	if (locale === "tl") return tl_player_created_join_failed(inputs)
	if (locale === "vi") return vi_player_created_join_failed(inputs)
	if (locale === "ko") return ko_player_created_join_failed(inputs)
	if (locale === "de") return de_player_created_join_failed(inputs)
	if (locale === "ru") return ru_player_created_join_failed(inputs)
	if (locale === "tr") return tr_player_created_join_failed(inputs)
	if (locale === "it") return it_player_created_join_failed(inputs)
	if (locale === "pl") return pl_player_created_join_failed(inputs)
	if (locale === "uk") return uk_player_created_join_failed(inputs)
	if (locale === "hi") return hi_player_created_join_failed(inputs)
	if (locale === "ar") return ar_player_created_join_failed(inputs)
	if (locale === "ms") return ms_player_created_join_failed(inputs)
	if (locale === "bn") return bn_player_created_join_failed(inputs)
	if (locale === "zh-TW") return zh_tw2_player_created_join_failed(inputs)
	if (locale === "zh-HK") return zh_hk2_player_created_join_failed(inputs)
	if (locale === "ur") return ur_player_created_join_failed(inputs)
	if (locale === "fa") return fa_player_created_join_failed(inputs)
	if (locale === "sw") return sw_player_created_join_failed(inputs)
	if (locale === "nl") return nl_player_created_join_failed(inputs)
	return en_player_created_join_failed(inputs)
});